export default __webpack_public_path__ + "locales/nl/InfoPanel.json?hash=52a6c6f9c37a18731f9787d26557805e";